import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import classes from './Tooltip.module.css';
import './Tooltip.css';

const Tooltip = ({ children, text, className, showTooltip, modeOpen, notRemoveSpecialChars }) => {

    const tooltipInstanceRef = useRef();

    const { lang } = useSelector(state => state.translate);

    const removeSpecialChars = () => {
        if (!notRemoveSpecialChars)
            return text?.replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        return text
    }

    const beforeRenderHandler = () => {
        tooltipInstanceRef.current.content = (
            `<div class=${classes.Wrap}>
                ${text &&
            `<div class="${showTooltip === true ? classes.Tooltip : classes.HideTooltip} ${className}">${removeSpecialChars()}</div>`}
            </div>`
        );
        tooltipInstanceRef.current.dataBind();
    };

    return (
        <TooltipComponent
            offsetY={5}
            position='TopCenter'
            cssClass={`Tooltip ${className} ${classes[`MyLang_${lang}`]}`}
            showTipPointer={showTooltip}
            ref={tooltipInstanceRef}
            beforeRender={beforeRenderHandler}
            opensOn={modeOpen ? `${modeOpen}` : 'Hover'}
        >
            <div className="target">
                {children}
            </div>
        </TooltipComponent>
    );
};

export default Tooltip;
